export const STRAPI_HEADER_ITEM_TYPE = {
  SimpleLink: 'header.simple-link',
  MultipleMenu: 'header.multiple-menu',
  SingleMenu: 'header.single-menu',
} as const

export type StrapiHeaderItemType = (typeof STRAPI_HEADER_ITEM_TYPE)[keyof typeof STRAPI_HEADER_ITEM_TYPE]